export const withdrawPaymentSwitching = {
  withdrawPaymentSwitching: 'Withdraw Transaction',
  username: 'Username',
  paymentName: 'PaymentName',
  refCode1: 'Ref Code 1',
  status: 'Status',
  transactionId: 'Transaction ID',
  refCode3: 'Ref Code 3',
  createdAt: 'Created At',
  advanceFilter: 'Advance Filter',
  amount: 'Amount',
  message: 'Message',
  feeAmount: 'Fee Amount',
  finalAmount: 'Final Amount',
}
